import { render, staticRenderFns } from "./cart-items.vue?vue&type=template&id=c8ab56f8&scoped=true"
import script from "./cart-items.vue?vue&type=script&lang=ts"
export * from "./cart-items.vue?vue&type=script&lang=ts"
import style0 from "./cart-items.vue?vue&type=style&index=0&id=c8ab56f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ab56f8",
  null
  
)

export default component.exports